import MpdIcon from './MpdIcon.vue'

export default MpdIcon
